// extracted by mini-css-extract-plugin
module.exports = {"button":"e_hj","inner":"e_ij","innerText":"e_jj"};